module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Wood_MockedUp.d7a671d2.jpg";